(() => {
  'use strict';

  const VERSION = 'CANFOTO-ASAMA-04B-HOME-9-PROFILE-R1';
  const ROOT_SELECTOR = '.cf-home-hero[data-cf-home-experience="1"]';

  const FAMILY = Object.freeze({
    'cf-editorial':'slider',
    'cf-newsroom':'slider',
    'cf-chrome':'slider',
    'cf-redaxis':'slider',
    'cf-magazine':'storyrail',
    'cf-retrofuture':'storyrail',
    'cf-cinema':'storyrail',
    'cf-nature':'chapters',
    'cf-hyperpop':'chapters'
  });

  function profile() {
    return document.documentElement.getAttribute('data-cf-theme') || 'cf-editorial';
  }

  function familyFor(id) {
    return FAMILY[id] || 'slider';
  }

  function boot(root) {
    if (!root || root.dataset.cfHomeReady === '1') return;
    root.dataset.cfHomeReady = '1';

    const copies = Array.from(root.querySelectorAll('[data-cf-home-copy-slide]'));
    const media = Array.from(root.querySelectorAll('[data-cf-home-media-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-cf-home-dot]'));

    if (copies.length !== 2 || media.length !== 2 || dots.length !== 2) {
      root.dataset.cfHomeReady = 'invalid';
      return;
    }

    let index = 0;
    let timer = 0;
    let currentFamily = 'slider';
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

    const activate = (next) => {
      index = next === 1 ? 1 : 0;
      copies.forEach((node, i) => node.classList.toggle('is-active', i === index));
      media.forEach((node, i) => node.classList.toggle('is-active', i === index));
      dots.forEach((node, i) => {
        const active = i === index;
        node.classList.toggle('is-active', active);
        node.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    const stop = () => {
      if (timer) clearInterval(timer);
      timer = 0;
    };

    const start = () => {
      stop();
      if (currentFamily !== 'slider' || reduce || document.hidden) return;
      timer = setInterval(() => activate(index ? 0 : 1), 6500);
    };

    const applyProfile = (id) => {
      currentFamily = familyFor(id);
      root.dataset.cfHomeFamily = currentFamily;
      root.dataset.cfHomeProfile = id;
      activate(0);
      start();
    };

    dots.forEach((dot, i) => dot.addEventListener('click', () => {
      activate(i);
      start();
    }));

    document.addEventListener('visibilitychange', start);
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    window.addEventListener('canfoto:experience-change', (event) => {
      applyProfile(event?.detail?.current || profile());
    });

    applyProfile(profile());

    root.__CANFOTO_HOME_EXPERIENCE__ = Object.freeze({
      version: VERSION,
      familyMap: FAMILY,
      getIndex: () => index,
      getFamily: () => currentFamily,
      activate
    });
  }

  const run = () => document.querySelectorAll(ROOT_SELECTOR).forEach(boot);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once:true });
  } else {
    run();
  }

  window.debugCanFotoHomeProfiles = () => {
    const root = document.querySelector(ROOT_SELECTOR);
    const id = profile();
    const expectedFamily = familyFor(id);
    const canonical = document.querySelector('link[rel="canonical"]')?.href || null;
    const old = document.querySelector('[id*="custom_liquid_jekNmR"]');

    const result = {
      ok: Boolean(
        root &&
        root.dataset.cfHomeReady === '1' &&
        root.dataset.cfHomeFamily === expectedFamily &&
        root.dataset.cfHomeProfile === id &&
        root.querySelectorAll('[data-cf-home-copy-slide]').length === 2 &&
        root.querySelectorAll('[data-cf-home-media-slide]').length === 2 &&
        root.querySelectorAll('[data-cf-home-dot]').length === 2 &&
        (!old || getComputedStyle(old).display === 'none') &&
        canonical === 'https://www.canfoto.com/'
      ),
      version: VERSION,
      profile: id,
      family: root?.dataset.cfHomeFamily || null,
      expectedFamily,
      ready: root?.dataset.cfHomeReady || null,
      copySlides: root?.querySelectorAll('[data-cf-home-copy-slide]').length || 0,
      mediaSlides: root?.querySelectorAll('[data-cf-home-media-slide]').length || 0,
      dots: root?.querySelectorAll('[data-cf-home-dot]').length || 0,
      oldSliderHidden: old ? getComputedStyle(old).display === 'none' : null,
      canonical
    };

    console.log(result);
    return result;
  };
})();
(() => {
  'use strict';

  const VERSION = 'CANFOTO-ASAMA-04C-HOME-SEALED-CONTROLS-R1';

  function boot() {
    const nora = document.querySelector('.cf43-scroll-gated');
    const backTop = document.querySelector('.cf42-backtop');
    const footer =
      document.querySelector('.footer-group footer') ||
      document.querySelector('footer') ||
      document.querySelector('.footer-group');

    if (!nora || !backTop) return;

    let ticking = false;

    function progress() {
      const max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      if (max <= 0) return 0;
      return Math.max(0, Math.min(1, window.scrollY / max));
    }

    function applyNora() {
      ticking = false;
      const p = progress();
      const show = p >= 0.75;
      nora.classList.toggle('is-scroll-visible', show);
      nora.setAttribute('aria-hidden', show ? 'false' : 'true');
      nora.tabIndex = show ? 0 : -1;
      nora.dataset.cf43ScrollState = show ? 'VISIBLE' : 'HIDDEN';
      nora.dataset.cf43ScrollProgress = p.toFixed(4);
    }

    function scheduleNora() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(applyNora);
    }

    function showBackTop(show) {
      backTop.classList.toggle('is-visible', !!show);
      backTop.setAttribute('aria-hidden', show ? 'false' : 'true');
      backTop.tabIndex = show ? 0 : -1;
    }

    applyNora();
    showBackTop(false);

    window.addEventListener('scroll', scheduleNora, { passive:true });
    window.addEventListener('resize', scheduleNora, { passive:true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(scheduleNora).observe(document.documentElement);
    }

    if (footer && 'IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === footer) showBackTop(entry.isIntersecting);
        });
      }, { threshold:.01 }).observe(footer);
    } else if (footer) {
      const checkFooter = () => {
        const r = footer.getBoundingClientRect();
        showBackTop(r.top < window.innerHeight && r.bottom > 0);
      };
      window.addEventListener('scroll', checkFooter, { passive:true });
      window.addEventListener('resize', checkFooter, { passive:true });
      checkFooter();
    }

    backTop.addEventListener('click', () => {
      const reduced = window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top:0, left:0, behavior:reduced ? 'auto' : 'smooth' });
    });

    window.debugCanFotoHomeSealedControls = () => ({
      ok:true,
      version:VERSION,
      noraExists:Boolean(nora),
      noraThreshold:nora.dataset.cf43Threshold || null,
      noraState:nora.dataset.cf43ScrollState || 'HIDDEN',
      noraProgress:nora.dataset.cf43ScrollProgress || '0.0000',
      backTopExists:Boolean(backTop),
      backTopVisible:backTop.classList.contains('is-visible'),
      footerExists:Boolean(footer)
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once:true });
  } else {
    boot();
  }
})();

/* ==========================================================================
   CANFOTO · E1 FINAL1 · R2J-H6
   SHOP THE LOOK · LIVE-NATIVE EVENT PARITY ONLY
   Mouseenter -> LIVE theme LookbookElement.init() (untouched).
   Click/focus/touch -> the same native LookbookElement.select(index).
   NO Flickity API calls. NO cell mutation. NO reloadCells. NO resize.
   ========================================================================== */
(() => {
  'use strict';
  if (window.__CANFOTO_E1_FINAL1_R2J_H6_SHOP_LOOK__) return;
  window.__CANFOTO_E1_FINAL1_R2J_H6_SHOP_LOOK__ = true;

  const VERSION = 'CANFOTO-E1-FINAL1-R2J-H6-SHOP-LOOK-LIVE-NATIVE-EVENT-PARITY-R1';
  const q = (s, r = document) => r.querySelector(s);
  const qa = (s, r = document) => [...r.querySelectorAll(s)];

  function bind(shop) {
    if (!shop || shop.dataset.cfH6Bound === '1') return;
    const lookbook = q('lookbook-element', shop);
    if (!lookbook || typeof lookbook.select !== 'function') return;

    qa('.hotspot', lookbook).forEach((hotspot, index) => {
      const selectNative = () => lookbook.select(index);
      hotspot.addEventListener('click', selectNative);
      hotspot.addEventListener('focusin', selectNative);
      hotspot.addEventListener('touchstart', selectNative, { passive: true });
    });

    shop.dataset.cfH6Bound = '1';
  }

  function boot() {
    qa('body.template-index shop-the-look').forEach(bind);
    window.CANFOTO_E1_FINAL1_R2J_H6_SHOP_LOOK_STATE = {
      version: VERSION,
      count: qa('body.template-index shop-the-look[data-cf-h6-bound="1"]').length,
      behaviorOwner: 'THEME_JS_NATIVE_SHOPTHELOOK_LOOKBOOK_CAROUSEL'
    };
  }

  window.CanFotoShopLookH6 = {
    version: VERSION,
    boot,
    snapshot() {
      const shop = q('body.template-index shop-the-look');
      const lookbook = q('lookbook-element', shop || document);
      const carousel = q('carousel-element', shop || document);
      return {
        bound: shop?.dataset.cfH6Bound === '1',
        hotspotCount: lookbook ? qa('.hotspot', lookbook).length : 0,
        productCardCount: carousel ? qa('.product-card', carousel).length : 0,
        unifiedCardsInsideShopLook: carousel ? qa('.cf-unified-product-card', carousel).length : 0,
        selectedIndex: carousel?.carousel?.selectedIndex ?? null,
        flickityCells: carousel?.carousel?.cells?.length ?? null
      };
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  window.debugCanFotoShopLookDeferP2R1 = function(){
    const shop=q('shop-the-look');
    const carousel=shop?q('carousel-element',shop):null;
    const cards=carousel?qa('.product-card',carousel):[];
    const desktop=matchMedia('(min-width:1024px)').matches;
    const state=shop?.dataset.cfH7DeferredState||null;

    const result={
      sectionPresent:!!shop,
      carouselPresent:!!carousel,
      state,
      cardCount:cards.length,
      readyCount:cards.filter(c=>c.dataset.cfH7State==='READY').length,
      pendingCount:cards.filter(c=>c.dataset.cfH7State==='PENDING').length,
      untouchedCount:cards.filter(c=>!c.dataset.cfH7State).length,
      desktop,
      staleMobileStateOnDesktop:desktop && state==='MOBILE_NATIVE'
    };

    result.ok=!shop || (
      !!carousel &&
      cards.length>0 &&
      ['WAITING','LOADING','READY','MOBILE_NATIVE'].includes(state) &&
      result.staleMobileStateOnDesktop===false
    );

    console.table(result);
    return result;
  };

})();

/* ==========================================================================
   CANFOTO · E1 FINAL1 · R2J-H7
   SHOP THE LOOK · COLLECTION-CARD INTERNAL PARITY
   H6 native hotspot/Flickity behavior remains owner.
   Desktop only: enrich native card CONTENT using real Shopify product JSON.
   Outer .product-card cell is never replaced and its geometry is never written.
   ========================================================================== */
(() => {
  'use strict';
  if (window.__CANFOTO_E1_FINAL1_R2J_H7_SHOP_LOOK_CARD_PARITY__) return;
  window.__CANFOTO_E1_FINAL1_R2J_H7_SHOP_LOOK_CARD_PARITY__ = true;

  const VERSION = 'CANFOTO-E1-FINAL1-R2J-H7-SHOP-LOOK-COLLECTION-CARD-PARITY-R1';
  const PERFORMANCE_VERSION = 'CANFOTO-PERFORMANCE-P2-R1A-SHOP-LOOK-DEFER-RESILIENCE';
  const DESKTOP_MQ = matchMedia('(min-width:1024px)');
  let deferredObserver = null;
  const q = (s, r = document) => r.querySelector(s);
  const qa = (s, r = document) => [...r.querySelectorAll(s)];
  const clean = (v) => String(v ?? '').replace(/\s+/g, ' ').trim();
  const cache = new Map();

  const stripHtml = (html) => {
    const box = document.createElement('div');
    box.innerHTML = String(html || '');
    qa('script,style,noscript', box).forEach((x) => x.remove());
    return clean(box.textContent || '');
  };

  const excerpt = (text, max = 180) => {
    text = clean(text);
    if (text.length <= max) return text;
    const cut = text.slice(0, max + 1);
    const i = cut.lastIndexOf(' ');
    return (i > max * .65 ? cut.slice(0, i) : cut.slice(0, max)).trim() + '…';
  };

  const moneyMinor = (value) => {
    const n = Number(value);
    if (!Number.isFinite(n) || n <= 0) return '';
    return (Math.round(n) / 100).toLocaleString('tr-TR', { maximumFractionDigits: 0 }) + ' TL';
  };

  const handleFromUrl = (url) => {
    try {
      const u = new URL(url, location.href);
      const m = u.pathname.match(/\/products\/([^/?#]+)/);
      return m ? decodeURIComponent(m[1]) : '';
    } catch (_) {
      return '';
    }
  };

  const productUrl = (card) => {
    const a = q('a.product-card__title[href*="/products/"], .product-card__media a[href*="/products/"], a[href*="/products/"]', card);
    return a?.getAttribute('href') || a?.href || '';
  };

  async function loadProduct(handle, url) {
    if (!handle) throw new Error('NO_HANDLE');
    if (cache.has(handle)) return cache.get(handle);
    const path = `/products/${encodeURIComponent(handle)}.js`;
    const promise = fetch(path, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(async (res) => {
      if (!res.ok) throw new Error('PRODUCT_FETCH_' + res.status);
      const p = await res.json();
      const variants = Array.isArray(p?.variants) ? p.variants : [];
      const variant = variants.find((x) => x && x.available !== false) || variants[0] || null;
      const price = Number(variant?.price ?? p?.price ?? 0);
      const compare = Number(variant?.compare_at_price ?? p?.compare_at_price ?? 0);
      return {
        handle: clean(p?.handle) || handle,
        title: clean(p?.title),
        vendor: clean(p?.vendor),
        type: clean(p?.type),
        description: excerpt(stripHtml(p?.description || '')),
        available: p?.available !== false && variant?.available !== false,
        variantId: variant?.id ? String(variant.id) : '',
        variantCount: variants.length,
        priceMinor: Number.isFinite(price) ? price : 0,
        compareMinor: Number.isFinite(compare) && compare > price ? compare : 0,
        url: clean(p?.url) || url || `/products/${handle}`
      };
    }).catch((err) => {
      cache.delete(handle);
      throw err;
    });
    cache.set(handle, promise);
    return promise;
  }

  function fallbackProduct(card, url, handle) {
    const title = clean(q('.product-card__title', card)?.textContent || '');
    const vendor = clean(q('.product-card__top .caption,.product-card__top', card)?.textContent || '');
    const priceText = clean(q('product-price,.price,.price__sale', card)?.textContent || '');
    return {
      handle,
      title,
      vendor,
      type: 'Ürün',
      description: '',
      available: !q('.quick-add button[disabled],.quick-add [aria-disabled="true"]', card),
      variantId: clean(q('.quick-add [data-variant-id]', card)?.dataset?.variantId),
      variantCount: clean(q('.quick-add [data-variant-id]', card)?.dataset?.variantId) ? 1 : 0,
      priceMinor: 0,
      compareMinor: 0,
      priceText,
      url
    };
  }

  function normalizeNativeAction(card, p) {
    let quick = q('.quick-add', card);
    const soldout = p?.available === false;

    if (!quick) {
      const a = document.createElement('a');
      a.href = p?.url || '#';
      a.className = 'cf27-commerce-btn cf27-commerce-btn--cart';
      a.textContent = soldout ? 'Stokta Yok' : 'Sepete Ekle';
      if (soldout) {
        a.dataset.cfUcardStock = 'soldout';
        a.setAttribute('aria-disabled', 'true');
        a.tabIndex = -1;
      }
      return a;
    }

    quick.remove();
    quick.classList.add('cf-shoplook-native-add');
    if (soldout) quick.dataset.cfUcardStock = 'soldout';

    const action = q('button.button,a.button,button,a', quick);
    if (action) {
      const label = soldout || action.disabled ? 'Stokta Yok' : 'Sepete Ekle';
      action.classList.add('cf27-commerce-btn', 'cf27-commerce-btn--cart');
      action.dataset.cfUcardCanonicalLabel = label;
      action.setAttribute('aria-label', label);
      if (soldout || action.disabled) action.dataset.cfUcardStock = 'soldout';

      const btnText = q('.btn-text', action);
      if (btnText) {
        btnText.replaceChildren();
        const labelNode = document.createElement('span');
        labelNode.className = 'cf-ucard-native-label';
        labelNode.textContent = label;
        btnText.appendChild(labelNode);
      } else {
        action.textContent = label;
      }
    }
    return quick;
  }

  function makeBuyLink(p) {
    const a = document.createElement('a');
    a.className = 'cf27-commerce-btn cf27-commerce-btn--buy';
    a.textContent = 'Satın Al';
    const exact = Boolean(p?.variantCount === 1 && p?.variantId && p?.available);
    a.href = exact ? `/cart/${encodeURIComponent(p.variantId)}:1?checkout` : (p?.url || '#');
    a.dataset.cfUcardBuyMode = exact ? 'EXACT_SINGLE_VARIANT' : 'PRODUCT_SELECTION';
    return a;
  }

  function buildCopy(p, action) {
    const copy = document.createElement('div');
    copy.className = 'cf-ucard-copy';
    copy.dataset.cfUcardSurface = 'shoplook';
    copy.dataset.cfUcardCopyOrder = 'vendor,type,title,description,source,price,cta,actions';

    const vendor = document.createElement('small');
    vendor.className = 'cf-ucard-vendor';
    vendor.textContent = p?.vendor || '';

    const type = document.createElement('span');
    type.className = 'cf-ucard-type';
    type.textContent = (p?.type || 'Ürün') + ' →';

    const title = document.createElement('h3');
    title.className = 'cf-ucard-title';
    const titleLink = document.createElement('a');
    titleLink.href = p?.url || '#';
    titleLink.textContent = p?.title || '';
    title.appendChild(titleLink);

    const description = document.createElement('p');
    description.className = 'cf-ucard-description';
    description.textContent = p?.description || 'Ürün açıklaması yüklenemedi.';

    const source = document.createElement('span');
    source.className = 'cf-ucard-description-source';
    source.textContent = 'Gerçek ürün açıklamasından';

    const price = document.createElement('div');
    price.className = 'cf-ucard-price';
    const current = document.createElement('b');
    current.textContent = moneyMinor(p?.priceMinor) || p?.priceText || '';
    price.appendChild(current);
    if (Number(p?.compareMinor || 0) > Number(p?.priceMinor || 0)) {
      const old = document.createElement('del');
      old.textContent = moneyMinor(p.compareMinor);
      price.appendChild(old);
    }

    const cta = document.createElement('div');
    cta.className = 'cf-ucard-cta';
    const inspect = document.createElement('a');
    inspect.href = p?.url || '#';
    inspect.textContent = 'Ürünü incele';
    const arrow = document.createElement('span');
    arrow.textContent = '→';
    cta.append(inspect, arrow);

    const actions = document.createElement('div');
    actions.className = 'cf-ucard-actions';
    if (p?.available === false || action?.dataset?.cfUcardStock === 'soldout' || q('[data-cf-ucard-stock="soldout"]', action || document.createElement('span'))) {
      actions.dataset.cfUcardStock = 'soldout';
    }
    if (action) actions.appendChild(action);
    actions.appendChild(makeBuyLink(p));

    copy.append(vendor, type, title, description, source, price, cta, actions);
    return copy;
  }

  async function adaptCard(card) {
    if (!card || card.dataset.cfH7State === 'READY' || card.dataset.cfH7State === 'PENDING') return;
    const url = productUrl(card);
    const handle = handleFromUrl(url);
    const content = q('.product-card__content', card);
    if (!url || !handle || !content) return;

    card.dataset.cfH7State = 'PENDING';
    card.classList.add('cf-shoplook-collection-parity');
    const fallback = fallbackProduct(card, url, handle);

    let p = fallback;
    try {
      p = { ...fallback, ...(await loadProduct(handle, url)) };
    } catch (_) {}

    try {
      const action = normalizeNativeAction(card, p);
      content.replaceChildren(buildCopy(p, action));
      card.dataset.cfH7State = 'READY';
      card.dataset.cfH7Handle = handle;
      card.dataset.cfH7Source = p.description ? 'SHOPIFY_PRODUCT_JSON' : 'DOM_FALLBACK';
    } catch (err) {
      card.dataset.cfH7State = 'FAIL';
      card.dataset.cfH7Error = clean(err?.message || err);
    }
  }

  function publishState(shop, desktop, deferredState) {
    const cards = qa('carousel-element .product-card', shop);

    window.CANFOTO_E1_FINAL1_R2J_H7_SHOP_LOOK_STATE = {
      version: VERSION,
      performanceExtension: PERFORMANCE_VERSION,
      desktop,
      deferredState,
      nativeBehaviorOwner: 'CANFOTO-E1-FINAL1-R2J-H6-SHOP-LOOK-LIVE-NATIVE-EVENT-PARITY-R1',
      cardCount: cards.length,
      readyCount: qa('carousel-element .product-card[data-cf-h7-state="READY"]', shop).length,
      failedCount: qa('carousel-element .product-card[data-cf-h7-state="FAIL"]', shop).length
    };

    window.dispatchEvent(new CustomEvent('canfoto:shop-look-card-parity-ready', {
      detail: window.CANFOTO_E1_FINAL1_R2J_H7_SHOP_LOOK_STATE
    }));
  }

  async function enrichShop(shop) {
    if (!shop || shop.dataset.cfH7DeferredState === 'READY' ||
        shop.dataset.cfH7DeferredState === 'LOADING') return;

    const desktop = DESKTOP_MQ.matches;
    const cards = qa('carousel-element .product-card', shop);

    if (!desktop) {
      shop.dataset.cfH7DeferredState = 'MOBILE_NATIVE';
      publishState(shop, desktop, 'MOBILE_NATIVE');
      return;
    }

    shop.dataset.cfH7DeferredState = 'LOADING';
    await Promise.all(cards.map(adaptCard));
    shop.dataset.cfH7DeferredState = 'READY';
    publishState(shop, desktop, 'READY');
  }

  function disconnectDeferredObserver() {
    if (!deferredObserver) return;
    deferredObserver.disconnect();
    deferredObserver = null;
  }

  function armDeferred(shop) {
    if (!shop) return;

    if (!DESKTOP_MQ.matches) {
      disconnectDeferredObserver();

      /* If desktop enrichment has not already completed, keep the sealed
         mobile-native branch untouched. */
      if (shop.dataset.cfH7DeferredState !== 'READY') {
        shop.dataset.cfH7DeferredState = 'MOBILE_NATIVE';
        publishState(shop, false, 'MOBILE_NATIVE');
      }
      return;
    }

    if (shop.dataset.cfH7DeferredState === 'READY' ||
        shop.dataset.cfH7DeferredState === 'LOADING') {
      publishState(shop, true, shop.dataset.cfH7DeferredState);
      return;
    }

    shop.dataset.cfH7DeferredState = 'WAITING';

    if (!('IntersectionObserver' in window)) {
      enrichShop(shop);
      return;
    }

    disconnectDeferredObserver();
    deferredObserver = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      disconnectDeferredObserver();
      enrichShop(shop);
    }, {
      root: null,
      rootMargin: '900px 0px',
      threshold: .01
    });

    deferredObserver.observe(shop);
    publishState(shop, true, 'WAITING');
  }

  async function boot() {
    if (!document.body.classList.contains('template-index')) return;
    const shop = q('shop-the-look');
    if (!shop) return;

    armDeferred(shop);

    const onBreakpointChange = () => {
      armDeferred(shop);
    };

    if (DESKTOP_MQ.addEventListener) {
      DESKTOP_MQ.addEventListener('change', onBreakpointChange);
    } else {
      DESKTOP_MQ.addListener(onBreakpointChange);
    }
  }

  window.CanFotoShopLookH7 = {
    version: VERSION,
    performanceVersion: PERFORMANCE_VERSION,
    boot,
    enrichShop,
    armDeferred
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();

/* ==========================================================================
   CANFOTO · E1 FINAL1 · R2J-H16
   SHOP THE FEED · MOBILE CARD TAP BRIDGE
   OWNER: CANFOTO-E1-FINAL1-R2J-H16-SHOP-FEED-MOBILE-TAP-BRIDGE-R1

   PURPOSE:
   Native theme opens a feed drawer from .media-card__button.
   On mobile the old Home presentation layer hid that control, leaving the
   visible card/product thumbnails without a reliable opening route.
   This bridge preserves the native drawer owner and simply forwards a mobile
   card/thumb tap to the card's existing native action control.
   ========================================================================== */
(function(){
  'use strict';

  const VERSION='CANFOTO-E1-FINAL1-R2J-H16-SHOP-FEED-MOBILE-TAP-BRIDGE-R1';
  const MQ='(max-width: 860px)';
  let lastTouchX=0;
  let lastTouchY=0;
  let moved=false;

  function isMobile(){
    return !!(window.matchMedia && window.matchMedia(MQ).matches);
  }

  function inFeedCard(node){
    return node && node.closest
      ? node.closest('body.template-index #MainContent .shop-the-feed .media-card')
      : null;
  }

  function nativeAction(card){
    return card ? card.querySelector('.media-card__button') : null;
  }

  function shouldIgnore(target){
    return !!target.closest(
      '.media-card__button, a[href]:not(.media-card__button), ' +
      'input, select, textarea, [contenteditable="true"], ' +
      '.deferred-poster, video-media button'
    );
  }

  function openCard(card, source){
    const action=nativeAction(card);
    if(!action || action.getAttribute('aria-disabled')==='true') return false;

    try{
      action.click();
      document.documentElement.dataset.cfShopFeedMobileOpen='H16';
      window.CANFOTO_E1_FINAL1_R2J_H16_SHOP_FEED_STATE={
        version:VERSION,
        status:'READY',
        lastSource:source||'card',
        nativeActionTag:action.tagName,
        nativeActionControls:action.getAttribute('aria-controls')||'',
        mutationContract:{
          nativeDrawerOwner:'PRESERVED',
          feedData:'NO_TOUCH',
          productTruth:'NO_TOUCH',
          shopTheLook:'NO_TOUCH',
          collection:'NO_TOUCH',
          scoring:'NONE',
          ranking:'NONE'
        }
      };
      return true;
    }catch(err){
      console.error('CANFOTO H16 Shop Feed mobile open bridge:',err);
      return false;
    }
  }

  document.addEventListener('touchstart',function(e){
    if(!isMobile() || !inFeedCard(e.target) || !e.touches || !e.touches[0]) return;
    lastTouchX=e.touches[0].clientX;
    lastTouchY=e.touches[0].clientY;
    moved=false;
  },{passive:true,capture:true});

  document.addEventListener('touchmove',function(e){
    if(!isMobile() || !e.touches || !e.touches[0]) return;
    if(Math.abs(e.touches[0].clientX-lastTouchX)>12 ||
       Math.abs(e.touches[0].clientY-lastTouchY)>12){
      moved=true;
    }
  },{passive:true,capture:true});

  document.addEventListener('click',function(e){
    if(!isMobile()) return;

    const card=inFeedCard(e.target);
    if(!card || moved) return;

    /* Existing CTA/link keeps its native behavior. */
    if(e.target.closest('.media-card__button')) return;

    /* Product thumbnail buttons have no independent mobile route in the
       current native card. Forward those taps to the same feed drawer. */
    const thumb=e.target.closest('.horizontal-product__media');
    if(thumb){
      e.preventDefault();
      e.stopPropagation();
      openCard(card,'product-thumbnail');
      return;
    }

    /* Any otherwise non-interactive point of the visible card opens it. */
    if(shouldIgnore(e.target)) return;

    e.preventDefault();
    openCard(card,'card-surface');
  },true);

  document.documentElement.dataset.cfShopFeedMobileBridge='H16';
  window.CANFOTO_E1_FINAL1_R2J_H16_SHOP_FEED_STATE={
    version:VERSION,
    status:'READY',
    mutationContract:{
      nativeDrawerOwner:'PRESERVED',
      feedData:'NO_TOUCH',
      productTruth:'NO_TOUCH',
      shopTheLook:'NO_TOUCH',
      collection:'NO_TOUCH',
      scoring:'NONE',
      ranking:'NONE'
    }
  };
})();

